export const TERMS_HERO_IMAGE_CLASS = 'terms-hero-image' as const

/** Hero image height in the terms acceptance modal (first visible block). */
export const TERMS_HERO_IMAGE_HEIGHT = '60vh' as const

/** Modal shell width relative to the viewport. */
export const TERMS_MODAL_CONTENT_WIDTH = '85%' as const

/** Modal shell max height relative to the viewport. */
export const TERMS_MODAL_CONTENT_MAX_HEIGHT = '90dvh' as const
